import { render, staticRenderFns } from "./PanicReport.vue?vue&type=template&id=295c5b1e"
import script from "./PanicReport.vue?vue&type=script&lang=js"
export * from "./PanicReport.vue?vue&type=script&lang=js"
import style0 from "./PanicReport.vue?vue&type=style&index=0&id=295c5b1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports